import { picoapp } from 'picoapp'

import slaterWelcome from '@/components/slater-welcome.js'

import header from '@/components/header.js'
import productSelection from '@/components/product-selection.js'
import cartDrawer from '@/components/cartDrawer.js'
import cartDrawerItem from '@/components/cartDrawerItem.js'
import accountLogin from '@/components/accountLogin.js'
import product from '@/components/product.js'
import productCounter from '@/components/product-counter.js'
import ticker from '@/components/ticker.js'
import mm from '@/components/mm.js'
import tabs from '@/components/tabs.js'
import slider from '@/components/slider.js'
import banner from '@/components/banner.js'
import materials from '@/components/materials.js'
import faq from '@/components/faq.js'
import credits from '@/components/credits.js'
import accordion from '@/components/accordion.js'
import productForm from '@/components/productForm.js'
import options from '@/components/options.js'
import promo from '@/components/promo.js'
import text from '@/components/text.js'
import spacer from '@/components/spacer.js'
import testimonials from '@/components/testimonials.js'
import mobileSlider from '@/components/mobile-slider.js'
import notification from '@/components/notification.js'
import collection from '@/components/collection.js'
import coll from '@/components/coll.js'
import linktreeSlider from '@/components/linktree-slider.js'

const state = {
  cartOpen: false
}

const components = {
  slaterWelcome,
  accountLogin,
  header,
  productSelection,
  cartDrawer,
  cartDrawerItem,
  product,
  productCounter,
  ticker,
  mm,
  spacer,
  tabs,
  slider,
  banner,
  materials,
  faq,
  credits,
  accordion,
  productForm,
  options,
  promo,
  text,
  testimonials,
  mobileSlider,
  notification,
  collection,
  coll, 
  linktreeSlider
}

export default picoapp(components, state)
